import { getCollaboratorInitials } from '@modules/dashboard/helpers';
import { Avatar, AvatarGroup } from '@mui/material';
import { UserInfo } from 'generated/graphql';

const AVATAR_STYLE = {
  width: 20,
  height: 20,
  fontSize: '10px',
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
};

interface DashboardShareAvatarGroupProps {
  editors: UserInfo[];
}
export const DashboardShareAvatarGroup = ({
  editors,
}: DashboardShareAvatarGroupProps) => {
  return (
    <>
      {editors.length > 0 ? (
        <AvatarGroup
          max={1}
          componentsProps={{
            additionalAvatar: {
              sx: { ...AVATAR_STYLE, ml: 1 },
            },
          }}
        >
          {editors?.map((editor) => (
            <Avatar
              key={editor.id}
              sx={{
                ...AVATAR_STYLE,
                border: 'ActiveBorder',
              }}
            >
              {getCollaboratorInitials(editor)}
            </Avatar>
          ))}
        </AvatarGroup>
      ) : null}
    </>
  );
};
